"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuturesUsdmOrderList = void 0;
const futuresUsdm_1 = require("../types/binance/shared/futuresUsdm");
const shared_1 = require("../types/binance/websockets/shared");
const shared_2 = require("../utils/data/shared");
const futuresUsdm_2 = require("../utils/dataMappers/futuresUsdm");
const formatted_1 = require("../utils/eventFilters/formatted");
const misc_1 = require("../utils/misc");
const shared_3 = require("./shared");
class FuturesUsdmOrderList extends shared_3.OrderFuturesList {
    constructor(params) {
        super(params);
        const { exchangeInfo, positions } = params;
        this.exchangeInfo = exchangeInfo;
        this.adlQuantilesMap = new Map();
        if (positions) {
            positions.forEach((position) => {
                var _a;
                this.assetsUpdateStats.assetsNew.set(position.baseAsset, position.baseAsset);
                (_a = this.assetsUpdateStats.knownAssets) === null || _a === void 0 ? void 0 : _a.set(position.baseAsset, position.baseAsset);
            });
        }
        this.update(Object.assign({}, params));
    }
    static load(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { fetchOrders, fetchPositions, orders, positions } = params;
            let ordersPromise;
            let positionsPromise;
            if (fetchOrders !== undefined)
                ordersPromise = fetchOrders();
            if (fetchPositions !== undefined)
                positionsPromise = fetchPositions();
            const [ordersFetched, positionsFetched] = yield Promise.all([ordersPromise, positionsPromise]);
            const ordersToInit = ordersFetched || orders;
            const positionsToInit = positionsFetched || positions;
            return new FuturesUsdmOrderList(Object.assign(Object.assign({}, params), { orders: ordersToInit || [], positions: positionsToInit || [] }));
        });
    }
    updateLiquidationPrice(positions) {
        positions.forEach(position => {
            const uid = (0, misc_1.createPositionId)({
                symbol: position.symbol,
                side: position.positionSide
            });
            const knownPosition = this.positions.get(uid);
            if (knownPosition === undefined)
                return;
            this.positions.set(uid, Object.assign(Object.assign({}, knownPosition), { liquidationPrice: position.liquidationPrice }));
        });
    }
    updateAdlQuantile(adlQuantiles) {
        var _a, _b, _c, _d;
        const updatedValues = (0, misc_1.objectArrayToMap)(adlQuantiles, 'symbol');
        const oldKeys = this.adlQuantilesMap.keys();
        const newKeys = updatedValues.keys();
        for (let oldKey of oldKeys) {
            const newValue = updatedValues.get(oldKey);
            if (!newValue)
                this.adlQuantilesMap.delete(oldKey);
        }
        for (let newKey of newKeys) {
            const newValue = updatedValues.get(newKey);
            if (newValue)
                this.adlQuantilesMap.set(newKey, newValue);
        }
        for (let position of this.positionsArray) {
            const adlSource = (_b = (_a = this.adlQuantilesMap) === null || _a === void 0 ? void 0 : _a.get(position.symbol)) === null || _b === void 0 ? void 0 : _b.adlQuantile;
            const adl = (_d = (_c = adlSource === null || adlSource === void 0 ? void 0 : adlSource.BOTH) !== null && _c !== void 0 ? _c : adlSource === null || adlSource === void 0 ? void 0 : adlSource[position.positionSideOutput]) !== null && _d !== void 0 ? _d : 0;
            this.positions.set(position.uid, (Object.assign(Object.assign({}, position), { adl })));
        }
    }
    update(params) {
        var _a, _b, _c, _d;
        const { orders, positions, events, marketData, totalMarginBalance } = params;
        if (marketData)
            this.marketData = marketData;
        const orderEvents = events
            ? formatted_1.eventFormattedFiltersMap[shared_1.EWsBinanceFuturesEventTypes.ORDER_TRADE_UPDATE](events)
            : undefined;
        const accountEvents = events ? formatted_1.eventFormattedFiltersMap[shared_1.EWsBinanceFuturesEventTypes.ACCOUNT_UPDATE](events) : [];
        const orderEventsFiteredByTime = orderEvents === null || orderEvents === void 0 ? void 0 : orderEvents.filter(order => order.eventTime >= this.lastFetch).map(futuresUsdm_2.futuresUsdmOrderUpdateToFuturesUsdmOrderMapper); // TODO: remove
        const ordersFilteredByTime = [...(orders || []), ...(orderEventsFiteredByTime || [])];
        for (let order of ordersFilteredByTime) {
            if (this.config.removeInactive) {
                if (![futuresUsdm_1.EFuturesUsdmOrderStatus.NEW, futuresUsdm_1.EFuturesUsdmOrderStatus.PARTIALLY_FILLED].includes(order.status)) {
                    this.orders.delete(order.orderId);
                }
                else {
                    this.orders.set(order.orderId, order);
                }
            }
            else
                this.orders.set(order.orderId, order);
        }
        if (totalMarginBalance)
            this.totalMarginBalance = totalMarginBalance;
        // positions
        // update unPnl for old positions from marketPrice
        if (marketData)
            for (let position of this.positionsArray) {
                const markPrice = (_a = this.marketData.marketAssets.get(position.baseAsset)) === null || _a === void 0 ? void 0 : _a.quotes[misc_1.EAssets.USDT];
                const unPnl = markPrice ? shared_2.FuturesDataUtils.calcUnPnl({
                    positionAmount: position.positionAmt,
                    entryPrice: position.entryPrice,
                    markPrice: markPrice,
                    positionSide: position.positionSideOutput
                }).toString() : position.unrealizedPnl;
                const unPnlPercent = markPrice ? shared_2.FuturesDataUtils.calcUnPnlPercent({
                    positionAmount: position.positionAmt,
                    entryPrice: position.entryPrice,
                    unrealisedPnl: unPnl
                }).toString() : position.unrealizedPnlPercent;
                this.positions.set(position.uid, (Object.assign(Object.assign({}, position), { unrealizedPnl: unPnl, unrealizedPnlPercent: unPnlPercent })));
            }
        const positionFromEvents = (0, futuresUsdm_2.usdmAccountEventsToPositions)({
            accountEvents,
            exchangeInfo: this.exchangeInfo,
            knownPositions: this.positions,
        });
        const positionsToUpdate = [...positionFromEvents, ...(positions || [])];
        if (positionsToUpdate.length > 0)
            this.assetsUpdateStats.assetsNew.clear();
        this.assetsUpdateStats.assetsNull.clear();
        for (let position of positionsToUpdate) {
            const positionKey = position.uid;
            if (this.config.removeInactive) {
                if (position.positionAmt === '0') {
                    this.positions.delete(positionKey);
                    this.assetsUpdateStats.assetsNull.set(position.baseAsset, position.baseAsset);
                    (_b = this.assetsUpdateStats.knownAssets) === null || _b === void 0 ? void 0 : _b.delete(position.baseAsset);
                    this.assetsUpdateStats.assetsNew.delete(position.baseAsset);
                }
                else {
                    this.positions.set(positionKey, position);
                    this.assetsUpdateStats.assetsNull.delete(position.baseAsset);
                    if (((_c = this.assetsUpdateStats.knownAssets) === null || _c === void 0 ? void 0 : _c.get(position.baseAsset)) === undefined) {
                        this.assetsUpdateStats.assetsNew.set(position.baseAsset, position.baseAsset);
                        (_d = this.assetsUpdateStats.knownAssets) === null || _d === void 0 ? void 0 : _d.set(position.baseAsset, position.baseAsset);
                    }
                }
            }
            else
                this.positions.set(positionKey, position);
        }
    }
    fetchInitial() {
        return __awaiter(this, void 0, void 0, function* () {
            let ordersPromise;
            let positionsPromise;
            if (this.fetchOrders !== undefined)
                ordersPromise = this.fetchOrders();
            if (this.fetchPositions !== undefined)
                positionsPromise = this.fetchPositions();
            const [ordersFetched, positionsFetched] = yield Promise.all([ordersPromise, positionsPromise]);
            return {
                orders: ordersFetched || [],
                positions: positionsFetched || [],
            };
        });
    }
}
exports.FuturesUsdmOrderList = FuturesUsdmOrderList;
